import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, getPageTitle } from '../../utils/analytics';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const title = getPageTitle(location.pathname);
    document.title = title;
    trackPageView(location.pathname, title);
  }, [location.pathname]);

  return null;
};

export default RouteTracker;
